module.exports = __webpack_public_path__ + "public/images/tariffs/radio.365f1080bbf3f65256b02a0deab0e20d.svg";